import React from 'react'
import { Link, useLocation } from 'react-router-dom';

const NavMenu = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <nav id="navmenu" className="navmenu">
      <ul>
        <li><Link className={`nav-link ${isActive('/home') || isActive('/') ? 'active' : ''}`} to="/home"><i className="bi bi-house navicon"></i>Inicio</Link></li>
        <li><Link className={`nav-link ${isActive('/services') ? 'active' : ''}`} to="/services"><i className="bi bi-hdd-stack navicon"></i> Servicios</Link></li>
        <li><Link className={`nav-link ${isActive('/portfolio') ? 'active' : ''}`} to="/portfolio"><i className="bi bi-images navicon"></i> Portafolio</Link></li>
        <li><Link className={`nav-link ${isActive('/resume') ? 'active' : ''}`} to="/resume"><i className="bi bi-file-earmark-text navicon"></i> Experiencia</Link></li>
        <li><Link className={`nav-link ${isActive('/about') ? 'active' : ''}`} to="/about" ><i className="bi bi-person navicon"></i> Sobre nosotros</Link></li>
        <li><Link className={`nav-link ${isActive('/contact') ? 'active' : ''}`} to="/contact"><i className="bi bi-envelope navicon"></i> Contacto</Link></li>
      </ul>
    </nav>
  )
}

export default NavMenu;